module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    staticStyle: {
      "padding-left": "50px"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "authors-preface"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "200px",
      "width": "550px"
    }
  }, [_vm._v("Author’s Preface")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_c('strong', [_c('em', [_vm._v("Of Towns and Countries")])]), _vm._v(" is not an annotated biography but is carried by a lattice of memoirs, the lattice, like the one in our garden, being in a state of some disrepair.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("Persons who recognise their names in the book are historical. Others are not; any semblance to real persons is coincidental and bears no relation to the characters described. The Prologue and Epilogue have ornamental elements. The persons in these are historical but not all of the events associated with them are.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("The publication of this book was delayed by the Covid-19 calamity. Pandemics are not new; a century ago my grandfather died in another one. The knowledge of this helped shape my conviction that societal structures are vulnerable, and that we must develop more robust ways of living together.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("For readers who like to follow up on this there are two appendices: the first focusses on how cities might stop contributing to existential threads by climate change and other ‘unforeseen’ global perils; the second about three-quarters of a century worth of literature on this and related topics. The third appendix is an index of places that were visited in the course of the book’s journey; a lifelong voyage leading to the belief that we must start building a different kind of world.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("Aberfeldy, May 2020")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("Dirk Bolt")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd355748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0007.vue
// module id = 78
// module chunks = 0